import AxiosInstance from "../config/AxiosInstance";

export interface GratuityOptionPayload {
  id?: string;
  valueType: number;
  value: number;
  displayName?: string | null;
  position?: number;
  isDefault?: boolean;
}

export interface GratuitySettingPayload {
  locationId?: string | null;
  isEnabled: boolean;
  isTaxable: boolean;
  taxGroupId: string | null;
  allowCustomGratuity: boolean;
  customMaxPercent: number | null;
  changeToGratuityEnabled: boolean;
  percentBase: number;
  promptMode: number;
  roundUpExactToNext: boolean;
  options: GratuityOptionPayload[];
}

export const createGratuitySetting = async (payload: GratuitySettingPayload) => {
  try {
    const { data } = await AxiosInstance.post("/api/gratuity-settings/create", payload);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getGratuitySettingList = async (
  page: number = 1,
  limit: number = 10,
  filterLocationId: string = ""
) => {
  try {
    const { data } = await AxiosInstance.get("/api/gratuity-settings/get", {
      params: { page, limit, ...(filterLocationId ? { filterLocationId } : {}) },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getGratuitySettingById = async (id: string) => {
  try {
    const { data } = await AxiosInstance.get(`/api/gratuity-settings/get-one/${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateGratuitySetting = async (id: string, payload: GratuitySettingPayload) => {
  try {
    const { data } = await AxiosInstance.put(`/api/gratuity-settings/update/${id}`, payload);
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteGratuitySetting = async (id: string) => {
  try {
    const { data } = await AxiosInstance.delete(`/api/gratuity-settings/delete/${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};
